//have to be the same as in backend in ReservationOnline
export const STATUS_NEW    = 1; //pending
export const STATUS_ACCEPT = 2; //approved
export const STATUS_REJECT = 3; //rejected
export const STATUS_CANCELED = 4; //canceled
export const STATUS_ASSIGNED = 5; //assigned
export const STATUS_COMPLETED = 6; //completed
export const STATUS_NO_SHOW = 7; //no show
export const STATUS_COMPLETED_AND_REVIEWED = 8; //completed and view added
